import type { AccessRole, AccessRoleWithPermissions } from '@gat-ship/types'

export class AccessRoleDataBuilder {
  static addRolePermissions(
    value: AccessRoleWithPermissions,
    permissionCodes: string[]
  ) {
    return {
      ...value,
      permissionCodes: Array.from(
        new Set([...value.permissionCodes, ...permissionCodes])
      )
    }
  }

  static removeRolePermissions(
    value: AccessRoleWithPermissions,
    permissionCodes: string[]
  ) {
    return {
      ...value,
      permissionCodes: value.permissionCodes.filter(
        (code) => !permissionCodes.includes(code)
      )
    }
  }
  static createAccessRole({
    id,
    name,
    description
  }: {
    id: string
    name: string
    description: string
  }): AccessRole {
    return {
      id,
      name,
      description
    }
  }

  static changeAccessRoleName(
    accessRole: AccessRole,
    name?: string,
    description?: string
  ): AccessRole {
    return {
      ...accessRole,
      name: name ?? accessRole.name,
      description: description ?? accessRole.description
    }
  }

  static createAccessRoleWithPermissions({
    id,
    name,
    description,
    permissions
  }: {
    id: string
    name: string
    description: string
    permissions: string[]
  }): AccessRoleWithPermissions {
    return {
      ...this.createAccessRole({ id, name, description }),
      permissionCodes: permissions
    }
  }

  static changeNameOfAccessRoleWithPermissions(
    accessRole: AccessRoleWithPermissions,
    name?: string,
    description?: string
  ): AccessRoleWithPermissions {
    return {
      ...accessRole,
      name: name ?? accessRole.name,
      description: description ?? accessRole.description
    }
  }

  static copyAccessRoleWithPermissions(
    value: AccessRoleWithPermissions
  ): AccessRoleWithPermissions {
    return {
      ...this.createAccessRoleWithPermissions({
        id: value.id,
        name: value.name,
        description: value.description,
        permissions: value.permissionCodes
      })
    }
  }
}
